import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEO({
  title = 'Forside - Advokatfirmaet Kopp',
  description = 'Advokatfirma med fokus på miljø og bæredygtighed – målrettet rådgivning om krav til byggeri og infrastruktur',
  ogImage = '/_assets/environmental-protection-326923-1920-1024x683.jpg',
  canonicalUrl,
}) {
  const fullTitle = title.includes('Advokatfirmaet Kopp') ? title : `${title} - Advokatfirmaet Kopp ApS`;

  return (
    <Helmet>
      <html lang="da-DK" />
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
  );
}
